import styled from "styled-components"

import { Spinner } from "components/common/Spinner"

const LoadingScreenWrapper = styled.main<{ $background: string }>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: var(--text-inverse);
  background: ${({ $background }) => $background};

  svg,
  svg * {
    stroke: var(--text-inverse);
  }
`

const LoadingMessage = styled.p`
  margin: 0;
  font-size: 16px;
`

type LoadingScreenProps = {
  background: string
}

export const LoadingScreen = ({ background }: LoadingScreenProps) => (
  <LoadingScreenWrapper $background={background} role="status" aria-live="polite">
    <Spinner />
    <LoadingMessage>Loading…</LoadingMessage>
  </LoadingScreenWrapper>
)
